import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    session: {
      uid: null,
      isAuth: false,
      isReg: false
    },
    user: {
      email: null
    },
    GlobalData: {
      news: [],
      projects: []
    }
  },
  mutations: {
    changeSession(state, val) {
      state.session = val;
    },
    startSession({ commit }, session) {
      commit("changeSession", session);
      // if (!session.isReg) {
      //   dispatch("loadUser");
      // }
    },
    changeGlobalData(state, val) {
      state.GlobalData = val;
      state.waitData = false;
    }
  },
  actions: {
    async loadAllData({ commit }) {
      let data = {
        news: [],
        projects: []
      };
      // let publicData = await axios.get("/.netlify/functions/public-data");
      let publicData = await axios.get("/publicData.json");
      for (let p = 0; p < publicData.data.news.length; p++) {
        publicData.data.news[p].data.id =
          publicData.data.news[p].ref["@ref"].id;
        if (publicData.data.news[p].data.images.length > 0) {
          publicData.data.news[p].data.kostil = [];
          for (let i = 0; i < publicData.data.news[p].data.images.length; i++) {
            let imgObj = publicData.data.news[p].data.images[i].split("/");
             let obj = {
              source: imgObj
                .splice(imgObj.length === 7 ? 4 : 5, imgObj.length - 4)
                .join("/")
                .toString(),
              options: { type: "local" }
            };
            publicData.data.news[p].data.images[i] = publicData.data.news[p].data.images[i].replace(
              "s3.eu-central-1.amazonaws.com/img.stroikomp.com.ua/products/",
              "img.stroikomp.com.ua"
            );
            publicData.data.news[p].data.kostil.push(obj);
          }
        }
        publicData.data.news[p].data.err = false;
        publicData.data.news[p].data.ready = false;
        data.news.push(publicData.data.news[p].data);
      }

      for (let p = 0; p < publicData.data.projects.length; p++) {
        publicData.data.projects[p].data.id =
          publicData.data.projects[p].ref["@ref"].id;
        if (publicData.data.projects[p].data.images.length > 0) {
          publicData.data.projects[p].data.kostil = [];
          for (let i = 0; i < publicData.data.projects[p].data.images.length; i++) {
            let imgObj = publicData.data.projects[p].data.images[i].split("/");
            let obj = {
              source: imgObj
                .splice(imgObj.length === 7 ? 4 : 5, imgObj.length - 4)
                .join("/")
                .toString(),
              options: { type: "local" },
            };
            publicData.data.projects[p].data.images[i] =
              publicData.data.projects[p].data.images[i].replace(
                "s3.eu-central-1.amazonaws.com/img.stroikomp.com.ua/products/",
                "img.stroikomp.com.ua"
              );
            publicData.data.projects[p].data.kostil.push(obj);
          }
        }
        publicData.data.projects[p].data.err = false;
        publicData.data.projects[p].data.ready = false;
        data.projects.push(publicData.data.projects[p].data);
      }
      commit("changeGlobalData", data);
    },
  },
});
